import React, { useEffect, createElement } from 'react';
import { MapPinIcon, ExternalLinkIcon } from 'lucide-react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
// Load Leaflet CSS from CDN so its image assets resolve correctly
function useLeafletCss() {
  useEffect(() => {
    const id = 'leaflet-cdn-css';
    if (document.getElementById(id)) return;
    const link = document.createElement('link');
    link.id = id;
    link.rel = 'stylesheet';
    link.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
    document.head.appendChild(link);
  }, []);
}
// Fix default marker icons (otherwise they 404 in bundlers)
const markerIcon = new L.Icon({
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});
const POSITION: [number, number] = [45.954168, 15.438223];
export function Location() {
  useLeafletCss();
  return <section id="kje" className="py-20 px-6 scroll-mt-24" data-id="element-58">
      <div className="max-w-2xl mx-auto" data-id="element-59">
        <div className="text-center mb-12" data-id="element-60">
          <h2 className="text-4xl md:text-5xl mb-6" data-id="element-61">Kje?</h2>
          <div className="w-16 h-px bg-gold/50 mx-auto" data-id="element-62"></div>
        </div>

        <div className="flex flex-col items-center text-center space-y-6 p-8 bg-white/40 rounded-sm border border-olive/5 shadow-sm" data-id="element-63">
          <div className="w-12 h-12 rounded-full bg-ivory flex items-center justify-center text-gold shadow-sm" data-id="element-64">
            <MapPinIcon size={24} strokeWidth={1.5} data-id="element-65" />
          </div>
          <div className="w-full" data-id="element-66">
            <h3 className="text-2xl mb-3" data-id="element-67">Prostor za piknike</h3>
            <p className="font-sans text-soft-brown/90 leading-relaxed text-lg mb-8" data-id="element-68">
              Kobile pri Leskovcu pri Krškem
            </p>

            <div className="relative z-0 isolate w-full h-72 md:h-80 rounded-sm overflow-hidden border-4 border-white shadow-sm" data-id="element-69">
              <MapContainer center={POSITION} zoom={16} scrollWheelZoom={false} style={{
              height: '100%',
              width: '100%'
            }} data-id="element-70">
                <TileLayer attribution="Tiles &copy; Esri &mdash; Source: Esri, Maxar, Earthstar Geographics" url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}" data-id="element-71" />
                <Marker position={POSITION} icon={markerIcon} data-id="element-72">
                  <Popup data-id="element-73">
                    Prostor za piknike
                    <br data-id="element-74" />
                    Kobile pri Leskovcu pri Krškem
                  </Popup>
                </Marker>
              </MapContainer>
            </div>

            <a href="https://maps.app.goo.gl/p68sSqZRcX6M8irr7" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 mt-8 px-6 py-3 bg-olive text-ivory font-sans text-sm tracking-widest uppercase hover:bg-gold transition-colors duration-300 rounded-sm" data-id="element-75">
              <ExternalLinkIcon size={16} data-id="element-76" />
              Odpri v Google Maps
            </a>

            <p className="font-sans text-sm text-soft-brown/70 mt-6 italic" data-id="element-77">
              Sledite oznakam ob prihodu.
            </p>
          </div>
        </div>
      </div>
    </section>;
}